<template>
  <article class="tile is-child box" v-if="occurrences">
    <h4 class="title">Tickets <span v-if="internal">Internal</span></h4>
    <table class="table is-striped is-narrow">
      <thead>
      <tr class="is-primary">
        <th>#</th>
        <th>Subject</th>
        <th>Department</th>
        <th>Date</th>
        <th>User</th>
        <th>Status</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="occurrence in occurrences">
        <td>{{ occurrence.id }}</td>
        <td>{{ occurrence.subject }}</td>
        <td>{{ parseDepartament(occurrence.departament) }}</td>
        <td>{{ occurrence.created_at }}</td>
        <td>{{ occurrence.user }}</td>
        <td>{{ parseStatus(occurrence.status) }}</td>
        <td class="has-text-centered">
          <tooltip label="View" type="default" placement="left">
            <a class="button button-table is-small" @click="url(occurrence.id)">
              <i class="fa fa-eye"></i>
            </a>
          </tooltip>
        </td>
      </tr>
      </tbody>
    </table>
  </article>
</template>

<script>
  import message from '../../utils/message'
  import Tooltip from 'vue-bulma-tooltip'
  export default {
    data () {
      return {
        occurrences: null
      }
    },
    props: {
      service: {
        type: Object
      },
      internal: {
        type: Boolean,
        default: false
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
        this.$root.$on('reloadoccurrencesimple', reload => {
          this.loadData()
        })
      })
    },
    methods: {
      loadData () {
        let occurencesType = 'occurrences'
        if (this.internal) {
          occurencesType = 'occurrences/internal'
        }
        this.$http.get(this.$store.state.config.apiURL + '/services/' + this.service.id + '/' + occurencesType).then((response) => {
          this.occurrences = response.body
        }, (response) => {
          let propsData = {
            title: 'Error',
            message: response.body,
            type: 'danger',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          message.openMessage(propsData)
        })
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      },
      view (occurrence) {
        this.$router.push({name: 'Occurrence', params: {id: occurrence}})
      },
      url (occurrence) {
        this.$router.push({name: 'Occurrence', params: {id: occurrence}})
      },
      parseDepartament (content) {
        return this.$store.state.config.departaments[content].name
      },
      parseStatus (status) {
        return this.$store.state.config.status[status].name
      }
    },
    components: {
      Tooltip
    }
  }
</script>

<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .button-table {
    padding-top: 6px;
  }
</style>



// WEBPACK FOOTER //
// OccurrencesSimple.vue?e9554178